import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import React from "react";
import TermsAndConditionsService from "../../Services/TermsAndConditionsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { Voucher_Type } from "../../Services/VoucherServices";
import SunEditor from "suneditor-react";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getVoucherTypeBySettingsSections,
  SettingsSections,
  vouchersSettings,
} from "../../Services/SettingService";
interface Modelprops {
  onCancel: any;
  isModelOpen: boolean;
  id?: any;
  voucher?: Voucher_Type | undefined;
  setRefresh: any;
  voucherTitle?: string;
}
const AddTermsAndCondition = ({
  isModelOpen,
  onCancel,
  id,
  voucher,
  setRefresh,
}: Modelprops) => {
  const [form] = Form.useForm();
  const { currentClient, companySettings } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [voucherOption, setVoucherOption] = React.useState<{
    type: number;
    titleName: string;
  }>({ type: Voucher_Type.All, titleName: "" });
  const [loading, setLoading] = React.useState<boolean>(false);
  const [btnLoading, setBtnLoading] = React.useState<boolean>(false);
  const [termsAndCond, setTermsAndCond] = React.useState<any>();

  let vouchersSettings = companySettings?.setting?.vouchersSettings;
  switch (voucher) {
    case Voucher_Type.SalesVoucher:
    case Voucher_Type.SalesOrder:
    case Voucher_Type.Quotation:
    case Voucher_Type.PInvoice:
      vouchersSettings = vouchersSettings?.filter(
        (x) =>
          x.settingType === SettingsSections.Invoice ||
          x.settingType === SettingsSections.PInvoice ||
          x.settingType === SettingsSections.Quotation ||
          x.settingType === SettingsSections.SOrder
      );
      break;
    case Voucher_Type.PurchaseOrder:
    case Voucher_Type.PurchaseVoucher:
      vouchersSettings = vouchersSettings?.filter(
        (x) =>
          x.settingType === SettingsSections.PurInvoice ||
          x.settingType === SettingsSections.POrder
      );
      break;
    case Voucher_Type.CreditNote:
      vouchersSettings = vouchersSettings?.filter(
        (x) => x.settingType === SettingsSections.CrNote
      );
      break;
    case Voucher_Type.DebitNote:
      vouchersSettings = vouchersSettings?.filter(
        (x) => x.settingType === SettingsSections.DrNote
      );
      break;
  }
  const addTermsndCondData = () => {
    form.validateFields().then(async (val) => {
      console.log("val", val);
      let obj = {
        ...val,
        voucherTitle: val.voucherType.label,
        voucherType: getVoucherTypeBySettingsSections(
          vouchersSettings?.find(
            (vset: vouchersSettings) => vset.id === val.voucherType.value
          )?.settingType!
        ),
      };
      setBtnLoading(true);
      let res = await TermsAndConditionsService?.saveData(
        currentClient?.id,
        id,
        voucherOption.type ?? voucher,
        obj
      );
      if (res) {
        setBtnLoading(false);
        setRefresh((x: boolean) => !x);
        onCancel(false);
        openNotification(
          "success",
          `Term & Condition ${
            id ? "updated successfully." : "added successfully."
          }`
        );
        onCancel(false);
      } else {
        setBtnLoading(false);
        openNotification("error", "error");
      }
    });
  };
  console.log("Voucher Type", voucher, vouchersSettings);
  React.useEffect(() => {
    if (id) {
      const getDatabyId = async () => {
        setLoading(true);
        let res = await TermsAndConditionsService?.getTermsAndConditionbyId(
          currentClient?.id,
          id,
          voucher
          // voucherTitle
        );
        // console.log("response", res);

        // if (res?.result?.termNConditions !== undefined) {
        //   setTermsAndCond(res?.result?.termNConditions);
        // } else {
        //   form?.setFieldsValue({
        //     termNConditions: res?.result?.termNConditions,
        //   });
        // }

        if (res) {
          setTermsAndCond(res?.result?.termNConditions);
          let selVoucherSetting = vouchersSettings?.find(
            (vSet: vouchersSettings) => vSet.title === res?.result?.voucherTitle
          );
          setVoucherOption({
            type: selVoucherSetting?.id!,
            titleName: res?.result?.voucherTitle,
          });
          form?.setFieldsValue({
            templateName: res?.result?.templateName,
            termNConditions: res?.result?.termNConditions,
            voucherType: {
              label: res?.result?.voucherTitle,
              value: selVoucherSetting?.id,
            },
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      };
      getDatabyId();
    }
  }, []);

  const handleSunEditorChange = (content: any) => {
    form.setFieldsValue({
      termNConditions: content,
    });
  };
  return (
    <>
      <Modal
        width={1000}
        open={isModelOpen}
        onCancel={() => onCancel(false)}
        title={`${id ? "Update" : "Add"} Terms & Conditions`}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => onCancel(false)}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button
              loading={btnLoading}
              type="primary"
              onClick={() => addTermsndCondData()}
            >
              {id ? "Update" : "Save"}
            </Button>
          </div>
        }
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 20 }} />}
          spinning={loading}
        >
          <Divider className="ca-model-css" />

          <Form form={form} labelAlign="left" requiredMark={true}>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="templateName"
                  label="Template Name"
                  labelCol={{ span: 8 }}
                  rules={[
                    { required: true, message: "Template's name is required" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="voucherType"
                  label="Voucher Template"
                  labelCol={{ span: 8 }}
                  labelAlign="right"
                  rules={[
                    { required: true, message: "Voucher type is required." },
                  ]}
                >
                  <Select
                    showSearch
                    labelInValue
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder="Select voucher template..."
                    options={vouchersSettings?.map((x: vouchersSettings) => ({
                      label: x?.title,
                      value: x?.id,
                      key: x?.id,
                      title: "",
                    }))}
                    onChange={(x: any) => {
                      setVoucherOption({
                        type: Number(x.value),
                        titleName: x.label,
                      });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name="termNConditions"
              label="Terms & Conditions"
              rules={[
                { required: true, message: "Term and condition is required." },
              ]}
            >
              <SunEditor
                setContents={termsAndCond}
                setOptions={{
                  buttonList: [
                    ["undo", "redo"],
                    ["font", "fontSize"],
                    ["bold", "underline", "italic", "strike"],
                    ["fontColor", "hiliteColor"],
                    ["align", "list", "lineHeight"],
                    ["outdent", "indent"],
                    ["removeFormat"],
                  ],
                  defaultTag: "div",
                  showPathLabel: false,
                }}
                height="150px"
                onChange={handleSunEditorChange}
              />
            </Form.Item>
          </Form>
          <Divider className="ca-model-css" />
        </Spin>
      </Modal>
    </>
  );
};

export default AddTermsAndCondition;
